export default __webpack_public_path__ + "static/media/cqueezeThumb.72496489.jpg";